import { Outlet, useNavigate } from 'react-router-dom'
import React, { useEffect, useState } from 'react'

import { Box } from '@mui/material'
import { Button } from '../../components/New/Button/Button'
import DocumentHeader from '../../components/Helmet/DocumentHeader'
import { HeaderConstants } from '../../constants/HeaderConstants'
import NoRecord from '../../components/common/NoContent/NoRecord'
import NoRecordImage from '../../assets/images/setting.svg'
import { OrganizationType } from '../../enum/OrganizationType.enum'
import { ProjectType } from '../../enum/ProjectType.enum'
import Spinner from '../../components/common/Spinner/Spinner'
import { UrlForSalesforceConnect } from '../../utils/UrlUtils'
import { isEmpty } from 'lodash'
import { observer } from 'mobx-react-lite'
import routeConstants from '../../constants/RouteConstants'
import { useStoreContext } from '../../store/StoreContext'

const SalesforceAuditLayout: React.FC = () => {
  const { salesforceAuditStore, scopeStore, userStore, uiStore } =
    useStoreContext()
  const navigate = useNavigate()
  const storeLoading = salesforceAuditStore.getLoading()
  const [loading, setLoading] = useState<boolean>(true)

  const [auditData, setAuditData] = useState<Record<string, any>>({})
  const [showBottomBar, setShowBottomBar] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    if (
      userStore.getSelectedOrganization().type !==
        OrganizationType.FULL_STACK_ONLY &&
      scopeStore.getSelectedProject().type !== ProjectType.FULL_STACK_ONLY
    ) {
      salesforceAuditStore
        .getSalesforceAuditFromAPI()
        .then(() => {
          setAuditData(salesforceAuditStore.getAuditData())
          setShowBottomBar(true)
        })
        .catch((e) => {
          setAuditData({})
          setShowBottomBar(false)
        })
        .finally(() => {
          setLoading(false)
          uiStore.setGlobalLoader(false)
        })
    } else {
      navigate(routeConstants.REDIRECT)
      setLoading(false)
    }
  }, [scopeStore.getScope()])

  const handleConnectSalesforce = () => {
    window.location.href = UrlForSalesforceConnect(
      scopeStore.getScope()['organization-id'] as string,
      scopeStore.getScope()['project-id'] as string,
      scopeStore.getScope()['environment-id'] as string,
      'new',
      false
    )
  }

  const renderChild = () => {
    if (isEmpty(auditData)) {
      if (storeLoading || loading) return <Spinner />
      return (
        <div>
          <NoRecord
            imageSrc={NoRecordImage}
            style={{ height: '80vh' }}
            text={<div>Not connected to a Salesforce Organization yet.</div>}
            button={
              <>
                <Button
                  id='connect-salesforce'
                  size='medium'
                  type='filled'
                  disabled={userStore.getNoActiveSubscription()}
                  label='Connect Organization'
                  onClick={handleConnectSalesforce}
                />
              </>
            }
          />
        </div>
      )
    }
    return <Outlet />
  }

  return (
    <>
      <DocumentHeader header={HeaderConstants.SALESFORCE_AUDIT} />
      <Box display='flex' justifyContent='center'>
        {renderChild()}
      </Box>
    </>
  )
}

export default observer(SalesforceAuditLayout)
